module.exports = __webpack_public_path__ + "img/7_186.756f8866.png";